export const APP_NAME = 'اعصر مخك';
export const APP_DESCRIPTION = 'لعبة معلومات عامة متعددة اللاعبين';
export const BRANDING_READY = true; // Branding applied

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
  },
  GAME: {
    CREATE_ROOM: '/api/game/rooms',
    JOIN_ROOM: '/api/game/rooms/{roomCode}/join',
    GET_ROOM: '/api/game/rooms/{roomCode}',
  },
  ADMIN: {
    CATEGORIES: '/api/admin/categories',
    QUESTIONS: '/api/admin/questions',
    USERS: '/api/admin/users',
    ANALYTICS: '/api/admin/analytics',
  },
} as const;
